export default __webpack_public_path__ + "static/media/Grey Water Disposal - Grey.43c8306e.svg";